'use strict';

function Controller($state, $stateParams, pmtFilterService) {
	this.filter = pmtFilterService.parseFilter($stateParams);
	pmtFilterService.listenOnFilter(this, $state);
}

Controller.$inject = ['$state', '$stateParams', 'pmtFilterService'];

/**
 * Add onFilter listener to args
 * Use when elm module uses filter
 */
angular.module('pmtPlacesApp.services').component('pmtElmFilter', {
	template: `<pmt-elm
		ng-if="$ctrl.args"
		module="{{$ctrl.module}}"
		args="$ctrl.args"
		subscriptions="$ctrl.subscriptions"
		version="{{$ctrl.version}}"
		user="$ctrl.user"
		feature-flags="$ctrl.featureFlags"
		pmt-env="$ctrl.pmtEnv"
		page-title="{{$ctrl.pageTitle}}"
		filter="$ctrl.filter"
	></pmt-elm>`,
	controller: Controller,
	bindings: {
		module: '@',
		args: '<',
		subscriptions: '<',
		version: '@',
		user: '<',
		featureFlags: '<',
		pmtEnv: '<',
		pageTitle: '@'
	}
});
